export default "__VITE_ASSET__BCz$snmy__ 600w";